import httpClient from 'utils/httpClient'

export const upload = async (linkUUID: string, file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await httpClient.post(
    `/api/proposals/${linkUUID}/upload/`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return data
}
